import { useTranslation } from 'react-i18next';
import { default as styled } from 'styled-components';

import { fontTextMdRegular } from '@/styles/helpers';

const Heading = styled.span`
  font-weight: 600;
`;

const Container = styled.div`
  ${fontTextMdRegular}
`;

export const Hints = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Heading>{t('steps.mobileRedirect.tutorial.hintHeading')}</Heading>
      <ul>
        <li>{t('steps.mobileRedirect.tutorial.hints.hint1')}</li>
        <li>{t('steps.mobileRedirect.tutorial.hints.hint2')}</li>
      </ul>
    </Container>
  );
};
